<app-header  ></app-header>

<div class="container">
  <div class="centered text-center"><h3> Usuarios de los dispositivos</h3></div>
</div>


<!-- Body --> 
<!-- <div class="container">
    <div class="btn-group">
        <button type="button" class="btn btn-primary">Apple</button>
        <button type="button" class="btn btn-primary">Samsung</button>
        <button type="button" class="btn btn-primary">Sony</button>
      </div>  
</div>  -->

<div class="container">
  <div class="row"> 
    <div class="container" *ngIf="!sendCommand">
      <div class="label centered">
          <h4>Comandos: </h4>
      </div>
      <dx-menu
          #menu
          [dataSource]="commands"
          displayExpr="name"
          [showFirstSubmenuMode]="showFirstSubmenuModes"
          orientation="horizontal"
          submenuDirection="auto"
          [hideSubmenuOnMouseLeave]="false"
          (onItemClick)="itemClick($event)" >
      </dx-menu> 
    </div> 
    <!--div class="btn-group" >
        <div class="dx-field-value">
            <dx-button
            class="send"
            [width]="125" 
            text="Huellas"
            (onClick)="popupSendClick()"
                > 
            </dx-button>
        </div>

        <div class="dx-field-value">
            <dx-button
            class="send"
            [width]="125" 
            text="Editar Usuario"
            (onClick)="popupSendEditUserClick($event)"
                > 
            </dx-button>
        </div>
    </div-->  
</div>  
  <dx-data-grid
    id="userInfoGrid"
    class="table table-hover"
    [dataSource]="dataSource"
    [showBorders]="true"
    [remoteOperations]="true"
    (onEditingStart)="logEvent('editingStart',$event,'devicesInfoGrid')"
    (onInitNewRow)="logEvent('onInitNewRow',$event,'devicesInfoGrid')"
    (onRowInserting)="logEvent('onRowInserting',$event,'devicesInfoGrid')"
    (onRowInserted)="logEvent('onRowInserting',$event,'devicesInfoGrid')"
    (onRowUpdating)="logEvent('onRowUpdating',$event,'devicesInfoGrid')"
    (onRowUpdated)="logEvent('onRowUpdated',$event,'devicesInfoGrid')"
    (onRowRemoving)="logEvent('onRowRemoving',$event,'devicesInfoGrid')"
    (onRowRemoved)="logEvent('onRowRemoved',$event,'devicesInfoGrid')"
    (onSelectionChanged)="logEvent('onSelectionChanged',$event,'userInfoGrid')"
    (onCellClick)="logEvent('onCellClick',$event,'devicesInfoGrid')"
    
    >
    <dxo-paging [pageSize]="10"></dxo-paging>
    <dxo-selection
    [selectAllMode]="allMode"
    [showCheckBoxesMode]="checkBoxesMode" 
    mode="multiple" ></dxo-selection>
  <dxo-pager 
    [showPageSizeSelector]="10"
    [allowedPageSizes]="[10,20,30,40]"
    [showInfo]="true"></dxo-pager>
    <dxo-column-chooser
      [enabled]="true"
      [mode]="'select'"></dxo-column-chooser>
    <dxo-export
      [enabled]="true"
      fileName="Usuarios"
      [allowExportSelectedData]="true"></dxo-export>
    <dxo-filter-row
      [visible]="true"></dxo-filter-row>
    <dxo-header-filter 
      [visible]="true"></dxo-header-filter>
      
      <!-- PAra agregar o editar -->
    <dxo-editing mode="popup" [allowUpdating]="true"  [allowAdding]="false"> 
             
        <dxo-popup title="Información del usuario"
                    [showTitle]="true"
                    [width]="700"
                    [position]="{ my: 'top', at: 'top' }">
        </dxo-popup>
    </dxo-editing>

    <!-- Columnas -->
    <dxi-column
      dataField="userPin"
      caption="Pin del usuario"
      [editorOptions]="{disabled: false}"></dxi-column>
    <dxi-column
      dataField="name"
      caption="Nombre del usuario"
      [editorOptions]="{disabled: false}"></dxi-column>
    <dxi-column dataField="privilege" 
        [editorOptions]="{disable: true}"
        caption="Privilegio">
        <dxo-lookup [dataSource]="states" displayExpr="Name" valueExpr="ID"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="mainCard" 
        [editorOptions]="{disable: true}"
        caption="Tarjeta">
    </dxi-column>    
    <!--dxi-column 
      dataField="password"
      caption="Password"
      [visible]="false"
      [editorOptions]="{visible: false}">
    </dxi-column-->
      <!-- <dxi-column
      dataField="countDevicesSN"
      caption="Dispositivos:"
      [editorOptions]="{disabled: true}"></dxi-column> -->
      <dxi-column type="buttons" [width]="110">
        <dxi-button name="edit" hint="Editar" icon="edit"></dxi-button>
        <dxi-button
          hint="Biometrías"
          icon="copy"
          [visible]="true"
          [disabled]="false"
          [onClick]="showBioTemplates"
        ></dxi-button>
      </dxi-column>
  </dx-data-grid>  

</div>
 
  
<!-- Formulario para sincronizar información de los usuarios en los dispositivos Solo los datos de un uusarios. --> 
<div class="row">
    <dx-popup class="popup" [width]="750" [showTitle]="true"
        title="Editar Usuario" [dragEnabled]="true" 
        [closeOnOutsideClick]="true"
        [(visible)]="popupSynchronizeUser">
            <dx-scroll-view > 
                <!-- *dxTemplate="let data of 'content'" -->
                   <div class="container">
                    <h1>Selecciona los dispositivos </h1>
                    <form #theForm = "ngForm"  autocomplete="false">
                      <div class="dx-fieldset">
                        <div class="dx-field">
                          <div class="dx-field-label">Mensaje:</div>
                          <dx-lookup
                              [(ngModel)]="IUserMSGModel.messageId"
                              name= "messageId"
                              [value]="IUserMSGModel.messageId"
                              [dataSource]="mensajes"
                              placeholder="Select an item" 
                              displayExpr="Name"
                              valueExpr="ID"
                              class="dx-field-value">
                          </dx-lookup>
                        </div>
                      </div>
                      <div class="dx-fieldset" *ngIf="vMensaje">
                        <div class="dx-field">
                          <div class="dx-field-label">Tipo de Mensaje</div>
                          <dx-lookup
                              [(ngModel)]="IUserMSGModel.type"
                              name= "type"
                              [value]="IUserMSGModel.type"
                              [dataSource]="msgType"
                              placeholder="Select an item" 
                              displayExpr="Name"
                              valueExpr="ID"
                              class="dx-field-value">
                          </dx-lookup>
                        </div>

                        <!--div class="dx-field">
                          <div class="dx-field-label">Mensaje</div>
                          <div class="dx-field-value">
                              <dx-text-box
                                name= "message"  
                                [value]="IUserMSGModel.message"
                                [(ngModel)]="IUserMSGModel.message" ></dx-text-box>
                          </div>
                        </div-->
                        <div class="dx-field">
                          <div class="dx-field-label">Fecha incio</div>
                          <div class="dx-field-value">
                              <dx-date-box
                                  [value]="IUserMSGModel.startTime"
                                  type="datetime"
                                  name="startTime"
                                  displayFormat="d/MM/yyyy HH:mm:ss"
                                  [(ngModel)]="IUserMSGModel.startTime" 
                                  (onValueChanged)="onValueChangedDateStart($event)" >
                              </dx-date-box>
                          </div>
                          <!-- {{attlogCommand.dateStart | json}} -->
                          <!-- [(ngModel)]="Students.dob|date:'dd/MM/yyyy'" -->
                        </div>
                        <div class="dx-field">
                          <div class="dx-field-label">Duración</div>
                          <div class="dx-field-value">
                              <dx-text-box
                              name= "duration"  
                              [value]="IUserMSGModel.duration"
                              [(ngModel)]="IUserMSGModel.duration" ></dx-text-box>
                          </div>
                        </div>
                      </div>
                        <!--div class="dx-fieldset">
                            <div class="dx-field">
                                <div class="dx-field-label">PIN</div>
                                <div class="dx-field-value">
                                    <dx-text-box  
                                      [disabled]="true" 
                                      [value]="selectedUser.userPin"></dx-text-box>
                                </div>
                            </div>

                            <div class="dx-field">
                                <div class="dx-field-label">Nombre de usuario</div>
                                <div class="dx-field-value">
                                    <dx-text-box  
                                      [(ngModel)]="selectedUser.userName"
                                      [value]="selectedUser.userName"
                                      name="userName"></dx-text-box>
                                </div>
                            </div>
                           
                            <div class="dx-field">
                              <div class="dx-field-label">Tipo de usuario</div>
                              <dx-lookup
                                  [(ngModel)]="selectedUser.privilege"
                                  name= "privilege"
                                  [value]="selectedUser.privilege"
                                  [dataSource]="states"
                                  placeholder="Select an item" 
                                  displayExpr="Name"
                                  valueExpr="ID"
                                  class="dx-field-value">
                              </dx-lookup>
                            </div>
                        </div-->
                        <!-- <dxi-column dataField="selectedUser.privilege" 
                        [editorOptions]="{disable: true}"
                        caption="Privilegio">
                    <dxo-lookup [dataSource]="states" 
                                displayExpr="Name"
                                valueExpr="ID">
                    </dxo-lookup>
                    </dxi-column> -->

                      <dx-data-grid
                      id="devicesInfoGrid"
                      class="table table-hover"
                      [dataSource]="listdevices"
                      [showBorders]="true"
                      [remoteOperations]="true" 
                      (onSelectionChanged)="logEvent('onSelectionChanged',$event,'devicesInfoGrid')"
                      (onCellClick)="logEvent('onCellClick',$event,'devicesInfoGrid')">
                      
                      <dxo-paging [pageSize]="4"></dxo-paging>
                      <dxo-selection
                      [selectAllMode]="allMode"
                      [showCheckBoxesMode]="checkBoxesMode" mode="multiple" >
                    </dxo-selection>
                    <dxo-pager 
                      [showPageSizeSelector]="4"
                      [allowedPageSizes]="[4,12,24]"
                      [showInfo]="true"></dxo-pager>
                      <dxo-column-chooser
                        [enabled]="false"
                        [mode]="'select'"></dxo-column-chooser> 
                      <dxo-filter-row
                        [visible]="true"></dxo-filter-row>
                      <dxo-header-filter 
                        [visible]="true"></dxo-header-filter> 
                      <!-- Columnas -->
                      <dxi-column dataField="deviceSN" 
                                  caption="Numero de serie"  
                                  [width]="140" 
                                  [editorOptions]="{ disabled: editorOptions }"></dxi-column>
                      <dxi-column dataField="deviceName" 
                                  caption="Descripción"  
                                  [width]="140" 
                                  [editorOptions]="{ disabled: editorOptions }"></dxi-column>
                         
                    </dx-data-grid>  
                            <div class="footer-copyright text-left py-3">
                                <div class="dx-field">
                                        <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  
                                        (click)="onSynchronizeEditUserCommand()"
                                            [disabled]="theForm.invalid" >
                                                Enviar
                                        </button>
                                </div>
                            </div> 
                        </form>
                    </div>
            </dx-scroll-view>
    </dx-popup>
  </div>

<!-- Formulario para sincronizar información de los usuarios en los dispositivos. --> 
<div class="row">
  <dx-popup class="popup" [width]="750" [showTitle]="true"
      title="{{popupTitle}}" [dragEnabled]="true" 
      [closeOnOutsideClick]="true"
      [(visible)]="popupSynchronizeFingerprint">
          <dx-scroll-view > 
              <!-- *dxTemplate="let data of 'content'" -->
                 <div class="container">
                  
                  <form #theForm = "ngForm"  autocomplete="false">
                    <div class="container" *ngIf="vDevices">
                    <h1>Selecciona los dispositivos </h1>
                    <dx-data-grid
                    id="devicesInfoGrid"
                    class="table table-hover"
                    [dataSource]="listdevices"
                    [showBorders]="true"
                    [remoteOperations]="true" 
                    (onSelectionChanged)="logEvent('onSelectionChanged',$event,'devicesInfoGrid')"
                    (onCellClick)="logEvent('onCellClick',$event,'devicesInfoGrid')"
                    
                    >
                    <!-- <dxo-paging [pageSize]="4"></dxo-paging> -->
                    <dxo-selection
                    [selectAllMode]="allMode"
                    [showCheckBoxesMode]="checkBoxesMode" mode="multiple" >
                  </dxo-selection>
                  <dxo-pager 
                    [showPageSizeSelector]="8"
                    [allowedPageSizes]="[8,16,32,40]"
                    [showInfo]="true"></dxo-pager>
                    <dxo-column-chooser
                      [enabled]="false"
                      [mode]="'select'"></dxo-column-chooser> 
                    <dxo-filter-row
                      [visible]="true"></dxo-filter-row>
                    <dxo-header-filter 
                      [visible]="true"></dxo-header-filter> 
                    <!-- Columnas -->
                    <dxi-column dataField="deviceSN" 
                                caption="Numero de serie"  
                                [width]="140" 
                                [editorOptions]="{ disabled: editorOptions }"></dxi-column>
                    <dxi-column dataField="deviceName" 
                              caption="Descripción"  
                              [width]="140" 
                              [editorOptions]="{ disabled: editorOptions }"></dxi-column>
                  </dx-data-grid> 
                </div> 
                    <div class="footer-copyright text-left py-3">
                      
                      <div class="dx-field" *ngIf="popupcmd == 'ResetPassword'">
                        <div class="dx-field-label">Nueva Contraseña </div>
                        <div class="dx-field-value">

                          <dx-text-box mode="password" placeholder="Contraseña" [(value)]="password"> 
                            <dx-validator>
                              <dxi-validation-rule type="required" message="Contraseña requerida"></dxi-validation-rule>
                            </dx-validator>
                          </dx-text-box>
                        </div>
                      </div>
                      <div class="dx-field">
                        <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  (click)="onSynchronizeFingerprintCommand()" 
                          [disabled]="theForm.invalid" *ngIf="popupcmd == 'TransfUsuario'">Transferir Usuarios 
                        </button>
                        <div *ngIf="popupcmd == 'BorraBiometria'">
                        <p class="text-danger font-weight-bold">Advertencia: Esta acción borrará las biometrias en los dispositivos seleccionados </p>
                        <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  (click)="onSynchronizeBiometria()" 
                        [disabled]="theForm.invalid" >Borrar Biometrías 
                        </button>
                        </div>
                        <div *ngIf="popupcmd == 'BorraUsuario'">
                          <p class="text-danger font-weight-bold">Advertencia: Esta acción borrará usuario(s) en todos los dispositivos</p>
                          <button type="submit" class="btn btn-lg btn-info btn-block btnlog mt-4"  (click)="onSynchronizeBorraUsuario()" 
                          [disabled]="theForm.invalid" *ngIf="popupcmd == 'BorraUsuario'">Borrar Usuario(s)
                          </button>  
                        </div>
                        <!--input type="text" id="password" class="fadeIn second" name="password" placeholder="Nueva Contraseña"
                          *ngIf="popupcmd == 'ResetPassword'"-->
                        <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  (click)="onResetPassword()" 
                        [disabled]="theForm.invalid" *ngIf="popupcmd == 'ResetPassword'">Cambiar Contraseña 
                        </button>

                        <button type="submit" class="btn btn-lg btn-info btn-block btnlog"  (click)="onSynchronizeGetBiometria()" 
                        [disabled]="theForm.invalid" *ngIf="popupcmd == 'TraeBiometria'">Traer Biometrías 
                        </button>                        

                      </div>
                    </div> 
                      </form>
                  </div>
          </dx-scroll-view>
  </dx-popup>
</div>

<!-- Formulario para mostrar biometrías de los usuarios en el servidor --> 
<div class="row">
  <dx-popup class="popup" [width]="750" [showTitle]="true"
      title="Biometrías Usuario" [dragEnabled]="true" 
      [closeOnOutsideClick]="true"
      [(visible)]="popupBioTemplate">
  <dx-scroll-view > 
    <div class="container">
      <h1>Biometrías de Usuario {{bUserPIN}}</h1>
        <dx-data-grid
        id="bioTemplateInfoGrid"
        class="table table-hover"
        [dataSource]="personBioTemplate"
        [showBorders]="true"
        [remoteOperations]="true">
        <dxo-paging [pageSize]="4"></dxo-paging>
      <dxo-pager 
        [showPageSizeSelector]="4"
        [allowedPageSizes]="[4,12,24]"
        [showInfo]="true"></dxo-pager>
        <dxo-column-chooser
        [enabled]="false"
        [mode]="'select'"></dxo-column-chooser> 
        <dxo-filter-row
        [visible]="true"></dxo-filter-row>
        <dxo-header-filter 
        [visible]="true"></dxo-header-filter> 
        <!-- Columnas -->
        <!--dxi-column dataField="userPIN" 
              caption="userPIN"  
              [editorOptions]="{ disabled: editorOptions }"></dxi-column-->
         <dxi-column dataField="deviceSN" 
              caption="Dispositivo"  
              [width]="150" 
              [editorOptions]="{ disabled: editorOptions }"></dxi-column>                        
        <dxi-column dataField="bioType" 
              caption="Tipo"  
              [editorOptions]="{ disabled: editorOptions }"></dxi-column>
        <dxi-column dataField="bioTypeName" 
              caption="Nombre"  
              [editorOptions]="{ disabled: editorOptions }"></dxi-column> 
        <dxi-column dataField="templateNo" 
              caption="No. Template"  
              [editorOptions]="{ disabled: editorOptions }"></dxi-column>                
        <dxi-column dataField="version" 
              caption="Versión"  
              [editorOptions]="{ disabled: editorOptions }"></dxi-column>                                         
      </dx-data-grid>  
    </div>
  </dx-scroll-view>
  </dx-popup>
</div>

<app-footer></app-footer>